import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDbInstance = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 16,
	viewBox: "0 0 14 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M0.332031 11.9719L1.89307 13.8011L2.03343 13.6344V1.93413L1.89307 1.75732L0.332031 3.58591V11.9719Z",
			fill: "#1A476F"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.89453 13.8012L4.87733 15.2924L5.00139 15.0928L5.00343 0.423936L4.87942 0.2677L1.89453 1.75408V13.8012Z",
			fill: "#1F5B98"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6658 3.58591L12.1043 1.75732L11.9297 1.81263L11.9644 13.6518L12.1043 13.8011L13.6658 11.9721V3.58591Z",
			fill: "#2D72B8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.1237 15.2924L12.1065 13.8012V1.75408L9.12161 0.2677L8.98047 0.458673L8.9825 15.0754L9.1237 15.2924Z",
			fill: "#5294CF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.87891 0.2677H9.11972V15.2926H4.87891V0.2677Z",
			fill: "#2D72B8"
		})
	]
});
export default SvgDbInstance;
